<div class="card-header">
  <app-breadcrumb currentPage="betalen met iDEAL"></app-breadcrumb>
</div>
<div class="card-body">
  <div class="form form-no-width">
    <h2>1. Kies een bank</h2>
    <div class="split">
      <div>
        <label for="ideal-bank-element">
          iDEAL Bank
        </label>
        <div id="ideal-bank-element"><!-- A Stripe Element will be inserted here. --></div>
        <div class="spacer"></div>
        <h2>2. algemene voorwaarden</h2>
        <label class="unselectable">
          <input [(ngModel)]="acceptedTerms" type="checkbox">ik ga akkoord met de
          <a class="link" routerLink="/help/algemene-voorwaarden" target="_blank">algemene voorwaarden</a>
        </label>
      </div>
      <div *ngIf="amount">
        <p>
          Voor
          <app-discount-price
            [amount]="amount / 100"
            [discount]="discount">
          </app-discount-price>
          krijgt u voor het bewind
        van {{client?.firstName}} {{client?.insertion}} {{client?.lastName}} toegang tot:
        </p>
        <ul class="">
          <li *ngIf="!(clientCreatedAtYear == year && clientStartYear <= clientCreatedAtYear-2)">
            de rekening en verantwoording over {{year-1}};
          </li>
          <li *ngIf="clientCreatedAtYear == year && clientStartYear <= clientCreatedAtYear-2">
            de rekening en verantwoording over {{year-1}} en eventuele oude nog niet ingediende rekening en verantwoordingen;
          </li>
          <li *ngIf="(year - clientStartYear) % 5 == 0">de vijfjaarlijkse evaluatie van {{year}};</li>
          <li>onze helpdesk voor vragen over het gebruik van Reveon.</li>
        </ul>
        <div>
          heeft u een vraag over de betaling? neem dan contact op via de chat rechtsonder of door te mailen naar <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.
        </div>
      </div>
    </div>
    <div class="spacer"></div>
    <button (click)="pay()"
            [matTooltipDisabled]="acceptedTerms && isBankPicked"
            matTooltip="kies een bank en ga akkoord met de algemene voorwaarden"
            class="btn check inverted accent">betalen
    </button>
  </div>
</div>
